import React from 'react';
import BarcodeReader from 'react-barcode-reader';

/**
 * CodeReader component for handling NFC/barcode input
 * 
 * Debugging features:
 * - Press Ctrl+D to toggle debug mode
 * - Debug mode shows a panel with scan history
 * - Debug mode includes a manual input field for testing without an NFC reader
 * - Yellow flash indicates when a scan is detected
 * - All scans are processed normally, even in debug mode
 * - Console logs show detailed scan information
 */
const CodeReader = ({ onScan }) => {
  return (
    <div className="CodeReader">
      <BarcodeReader
        avgTimeByChar={100}
        timeBeforeScanTest={200}
        onError={(err) => console.log('err', err)}
        onScan={(data) => (onScan ? onScan(data) : console.log('data', data))}
      />
    </div>
  );
};

export default CodeReader;
